import { ReactNode, VFC, memo, useCallback } from 'react';
import { Button } from '@chakra-ui/react';
import { useLoginUser } from "../../../hooks/providers/useLoginUserProvider";
import { useOpelog } from '../../../hooks/useOpelog';

type Props = {
  children: ReactNode;
  customObjId: string;
  size?: string;
  color?: string;
  isLoading?: boolean;
};

export const ListSfdcButton: VFC<Props> = memo((props) => {
  const {
    children,
    customObjId,
    size = 'xs',
    color = 'orange',
    isLoading = false,
  } = props;
  const { loginUser } = useLoginUser();
  const { OutputOpelog } = useOpelog();

  // SFDCのCASE問い合わせ画面に遷移
  const onClickSfdcButton = useCallback((customObjId: string) => {
    let url_template = 'https://';
    // url_template += process.env.REACT_APP_SFDC_URL ?? '';
    loginUser.envType === 'dev' && console.log(loginUser.sfdc_url);
    url_template += loginUser.sfdc_url;

    // 置換
    const url = url_template.replace('CUSTOM_OBJ_ID', customObjId);
    // 操作ログ登録
    OutputOpelog('sfdc', 'reference', "CUSTOM_OBJ_ID#" + customObjId);
    
    window.open(url);
  }, [loginUser,OutputOpelog]);

  return (
    <Button
      size={size}
      bg={
        color === 'gray'
          ? 'gray.200'
          : color === 'blue'
          ? 'blue.500'
          : 'orange.400'
      }
      color={color === 'gray' ? 'black' : color === 'white' ? 'white' : 'white'}
      _hover={{ opacity: 0.8 }}
      isLoading={isLoading}
      onClick={() => onClickSfdcButton(customObjId)}
    >
      {children}
    </Button>
  );
});
